module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Devices/CPU#1-898bc2ba53683221d2eebb7508b0c2a02783c0aab128744e91ff42f16a4a9b96.svg";